import React from 'react';
import { Grid, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import EirInformation from '../eir-information/EirInformation';
import StandaloneOfferCardContainer from './StandaloneOfferCardContainer';

const StandaloneOfferContainer = ({
  offers,
  discounts,
  cmsData,
  loading,
  onOfferSelect,
  onOfferUnSelect,
  addingTariff,
  selectedBundle,
}) => {
  const theme = useTheme();
  return (
    <Stack>
      <Grid item xs={12}>
        <EirInformation
          title={cmsData?.data?.attributes?.EirInformation_Handset?.title}
          description={cmsData?.data?.attributes?.EirInformation_Handset?.description}
          textAlign={cmsData?.data?.attributes?.EirInformation_Handset?.textAlign}
          useH1={cmsData?.attributes?.EirInformation_Handset?.useH1}
        />
      </Grid>
      <Grid item xs={12} sx={{ background: theme.palette.secondary.contrastText }}>
        <StandaloneOfferCardContainer
          loading={loading}
          offers={offers}
          discounts={discounts}
          onOfferSelect={onOfferSelect}
          onOfferUnSelect={onOfferUnSelect}
          addingTariff={addingTariff}
          selectedBundle={selectedBundle}
          isStandAloneHandset
        />
      </Grid>
    </Stack>
  );
};

export default StandaloneOfferContainer;
